import { Navigate, Route, Routes } from 'react-router-dom'
import HomeScene from '../pages/HomeScene'
import UploadFlow from '../pages/UploadFlow'
import PhoneUpload from '../pages/PhoneUpload'
import Login from '../pages/Login'
import PhoneLogin from '../pages/PhoneLogin'
import ContractDetail from '../pages/ContractDetail'
import OcrTest from '../pages/OcrTest'

/**
 * Route map (mirrors `docs/flow.md` §"Route map").
 *
 * `/`               → HomeScene       — illustrated scene, 3 zones (house/vehicle/person)
 * `/upload`         → UploadFlow      — QR → photo → OCR thinking → metadata reveal
 * `/upload/phone`   → PhoneUpload     — mobile capture page the upload QR points at (?token=)
 * `/login`          → Login           — photo-as-login stub (QR-first, on-device fallback)
 * `/login/phone`    → PhoneLogin      — mobile selfie page the login QR points at (?token=)
 * `/contract/:id`   → ContractDetail  — extracted contract preview + confirm
 * `/ocr-test`       → OcrTest         — dev probe: upload → raw JSON + preview side-by-side
 * `*`               → redirect to `/`
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeScene />} />
      <Route path="/upload/phone" element={<PhoneUpload />} />
      <Route path="/upload" element={<UploadFlow />} />
      <Route path="/login/phone" element={<PhoneLogin />} />
      <Route path="/login" element={<Login />} />
      <Route path="/contract/:id" element={<ContractDetail />} />
      <Route path="/ocr-test" element={<OcrTest />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
